<script>

import MapComponent from './components/MapComponent.vue'
import PlotComponent from './components/PlotComponent.vue'
import EventComponent from './components/EventComponent.vue'
import CountryFlag from 'vue-country-flag'

var moment = require('moment-timezone');
var md = require('markdown-it')({html: true});
import $ from 'jquery';

export default {
    name: 'App',

  components: {
    MapComponent,
    PlotComponent,
    EventComponent,
    CountryFlag
  },

  data: function () {
    return {
      // tz: 'Europe/Moscow',
      tz: 'ETC/GMT-3',
            apihost: process.env.VUE_APP_APIHOST,
      tab: 0,
      default_background_stations: {
        meteo: {
          moscow: [27611, 27511, 27417, 27419, 27428, 27618, 27523, 27625, 27606],
          spb: [22897, 22891, 26072, 26078, 26069, 26067, 26071, 26002]
        },
        air: {
          moscow: 'all',
          spb: 'all'
        }
      },
      background_stations: {
        meteo: {
          moscow: [27611, 27511, 27417, 27419, 27428, 27618, 27523, 27625, 27606],
          spb: [22897, 22891, 26072, 26078, 26069, 26067, 26071, 26002]
        },
        air: {
          moscow: 'all',
          spb: 'all'
        }
      },
      selected: null,
      show_netatmo: true,
      show_rhm: true,
      show_air: true,
      options: true,
      snackbar: false,
      snackbar_message: '',
      lock: true,
      story: {
        show: true,
        width: 400,
        border: 3
      },
      loading_app: true,
      loading_map: true,
      final_date: true,
      first_date: false,
      loading: true,
      timeidx: 0,
      min_date: moment(0),
      max_date: moment(0),
      in_min_date: false,
      in_max_date: false,
      min_date_all: {
        moscow: null,
        spb: null
      },
      max_date_all: {
        moscow: null,
        spb: null
      },
      show_time: {
        t0: true,
        t3: true,
        t6: true,
        t9: true,
        t12: true,
        t15: true,
        t18: true,
        t21: true,
      },
      date: null,
      time: null,
      datetime: null,
      datetime_show: null,
      show_help: false,
      show_info: false,
      timeStep: 3,
      transparency: 25,
      confidence: 75,
      confidence_up: 75,
      min_confidence: 0,
      menu2: false,
      filtering: ['Yes'],
      show_lyrs: ['points', 'fields'],
      standardize: false,
      stations: true,
      fields: true,
      pdk: {},
      variable: {
        meteo: 'temperature',
        air: 'pm10'
      },
      varspace: 'meteo',
      city: 'moscow',
      netatmo_vars: ['temperature', 'humidity', 'pressure'],
      interp: 'RBF',
      interp_methods: [
        { text: 'RBF', value : 'RBF' },
        { text: 'IDW', value : 'IDW' }
      ],
      filter_level: 4,
      levels: [
        { text: 'L1', value : 1 },
        { text: 'L2', value : 2 },
        { text: 'L3', value : 3 },
        { text: 'L4', value : 4 }
      ],
      aggrunit: 'hour',
      steps: {
        hour: 3,
        day: 1,
        week: 1,
        month: 1,
        year: 1
      },
      events: {
        moscow: [],
        spb: []
      },
      eventkey: 0,
    }; 
  },
  watch: {
        city(city) {
      this.min_date = this.min_date_all[city].clone();
      this.max_date = this.max_date_all[city].clone();

            // При смене города на spb, если выбрана вкладка air, устанавливаем day
      if (city === 'spb' && this.varspace === 'air' && this.aggrunit === 'hour') {
        this.aggrunit = 'day';
      }

      if (this.datetime < this.min_date || this.datetime > this.max_date) {
        if (this.datetime < this.min_date) {
          this.datetime = this.min_date.clone();
        } else {
          this.datetime = this.max_date.clone();
        }

        this.date = this.datetime.format('YYYY-MM-DD');
        this.time = this.datetime.hours();
        this.$refs['t' + this.time].$el.click();
      } else {
        this.in_min_date = this.date == this.min_date.format('YYYY-MM-DD');
        this.in_max_date = this.date == this.max_date.format('YYYY-MM-DD');
        this.final_date = this.datetime.clone().add(3, 'hours').isAfter(this.max_date);
        this.first_date = this.datetime.clone().subtract(3, 'hours').isBefore(this.min_date);
      }

      this.filter_timepickers();

      // Проверяем, нужно ли изменить выбранный показатель air при смене города
      this.checkAirVariable();
    },
    date: function(val) {
      if (this.datetime) {
        this.datetime.set({
          'year': val.slice(0, 4),
          'month': val.slice(5, 7)-1,
          'date': val.slice(8)
        });
      }
      this.in_min_date = val == this.min_date.format('YYYY-MM-DD');
      this.in_max_date = val == this.max_date.format('YYYY-MM-DD');

      // console.log('Changed date ' + this.in_min_date + ' ' + this.in_max_date);
    },
    in_min_date() {
      this.filter_timepickers();
    },
    in_max_date() {
      this.filter_timepickers();
    },
    time: function(val) {
      if (this.datetime) {
        this.datetime.hours(val);
      }
    },
        tab(val) {
          // Синхронизация varspace при изменении tab
          // Сначала устанавливаем aggrunit, потом меняем varspace,
          // чтобы PlotComponent получил правильный aggrunit до запуска fetch_data()
          if (val !== null && this.city === 'spb' && this.aggrunit === 'hour') {
            this.aggrunit = 'day';
          }
          this.varspace = val ? 'air' : 'meteo';
        },
    aggrunit() {
      this.update_dateshow();
    },
    aggrunits() {
      const valid = this.aggrunits.some(item => item.value === this.aggrunit);
      if (!valid) {
        this.aggrunit = this.aggrunits[0].value;
      }
    },
    datetime: {
      handler() {
        this.update_dateshow();
        this.final_date = this.datetime.clone().add(3, 'hours').isAfter(this.max_date);
        this.first_date = this.datetime.clone().subtract(3, 'hours').isBefore(this.min_date);
      },
      deep: true
    },
    loading_map() {
      // console.log(this.loading_map);
      this.loading = this.loading_map || this.loading_app;
    },
    loading_app() {
      // console.log(this.loading_app);
      this.loading = this.loading_map || this.loading_app;
    },
    // show_help(value) {
    //   if (value) {
    //     $.get(`${this.apihost}/mosclim/help/help_ru.md`, function(markdown) {
    //         $('#help').html(md.render(markdown));
    //     });
    //   }
    // },
        show_help(value) {
      if (value) {
        const lang = this.$i18n.locale;
		fetch(`${this.apihost}/uclim/content/help/help_${lang}.md`)
          .then(response => response.text())
          .then(markdown => {
            $('#help').html(md.render(markdown));
          })
          .catch(error => {
            console.error('Error loading help:', error);
          });
      }
    },
    // show_info(value) {
    //   if (value) {
    //     $.get(`${this.apihost}/mosclim/help/info_ru.md`, function(markdown) {
    //         $('#info').html(md.render(markdown));
    //     });
    //   }
    // }
    show_info(value) {
      if (value) {
        const lang = this.$i18n.locale;
        fetch(`${this.apihost}/uclim/content/help/info_${lang}.md`)
          .then(response => response.text())
          .then(markdown => {
            $('#info').html(md.render(markdown));
          })
          .catch(error => {
            console.error('Error loading info:', error);
          });
      }
    },
  },
  computed: {
    direction() {
      return this.story.show === false ? "Open" : "Closed";
    },
    cities() {
      return this.$i18n.t('cities')
    },
    aggrunits() {
      return this.cityspaceunits[this.city][this.varspace]
    },
    cityspaceunits() {
      return {
        moscow: {
          meteo: this.aggrunits_all,
          air: this.aggrunits_all,
        },
        spb: {
          meteo: this.aggrunits_all,
          air: this.aggrunits_all.filter(item => item.value !== 'hour')
        }
      }
    },
    aggrunits_all() {
      return this.$i18n.t('aggrunits')
    },
    vars() {
      const dict = this.$i18n.t('vars');

      let newdict = {
        meteo: Object.keys(dict.meteo).map(key => ({
          text: dict.meteo[key],
          value: key
        })),
        air: {
          moscow: Object.keys(dict.air.moscow).map(key => ({
            text: dict.air.moscow[key],
            value: key
          })),
          spb: Object.keys(dict.air.spb).map(key => ({
            text: dict.air.spb[key],
            value: key
          }))
        } ,
      }

      return newdict
    },
    nodehost() {
      return `${this.apihost}/netatmo`
    }
  },
    methods: {
    // Метод для проверки и корректировки выбранного показателя air при смене города
    checkAirVariable() {
      if (this.varspace === 'air') {
        // Получаем доступные показатели для текущего города
        const availableVars = this.vars.air[this.city];
        
        // Проверяем, есть ли выбранный показатель в списке доступных
        const currentVar = this.variable.air;
        const isAvailable = availableVars.some(varItem => varItem.value === currentVar);
        
        // Если текущий показатель недоступен, выбираем первый из доступных
        if (!isAvailable && availableVars.length > 0) {
          this.variable.air = availableVars[0].value;
        }
      }
    },
    set_loading_map(val) {
      this.loading_map = val;
    },
    show_snackbar(value) {
      if (typeof value === 'number') {
        // Confidence threshold — show "reduce confidence?" hint
        this.min_confidence = value;
        this.snackbar_message = this.$t('messages.confidence_hint', { confidence: value });
      } else {
        // String message (e.g., no_background_data) — show as-is
        this.snackbar_message = value;
      }
      this.snackbar = true;
    },
    filter_timepickers() {
      let internal = !(this.in_min_date || this.in_max_date);
      let min_hours = this.min_date.hours();
      let max_hours = this.max_date.hours();
      this.show_time.t0 = internal || ((0 >= min_hours) && this.in_min_date) || ((0 <= max_hours) && this.in_max_date);
      this.show_time.t3 = internal || ((3 >= min_hours) && this.in_min_date) || ((3 <= max_hours) && this.in_max_date);
      this.show_time.t6 = internal || ((6 >= min_hours) && this.in_min_date) || ((6 <= max_hours) && this.in_max_date);
      this.show_time.t9 = internal || ((9 >= min_hours) && this.in_min_date) || ((9 <= max_hours) && this.in_max_date);
      this.show_time.t12 = internal || ((12 >= min_hours) && this.in_min_date) || ((12 <= max_hours) && this.in_max_date);
      this.show_time.t15 = internal || ((15 >= min_hours) && this.in_min_date) || ((15 <= max_hours) && this.in_max_date);
      this.show_time.t18 = internal || ((18 >= min_hours) && this.in_min_date) || ((18 <= max_hours) && this.in_max_date);
      this.show_time.t21 = internal || ((21 >= min_hours) && this.in_min_date) || ((21 <= max_hours) && this.in_max_date);
    },
    update_dateshow() {
      switch (this.aggrunit) {
        case 'year':
          this.datetime_show = this.datetime.format('YYYY');
          break;
        case 'month':
          this.datetime_show = this.datetime.format('YYYY-MM');
          break;
        case 'week':
          this.datetime_show = this.datetime.clone().startOf('isoWeek').format('YYYY-MM-DD') + ' — ' + this.datetime.clone().startOf('isoWeek').add(6, 'days').format('YYYY-MM-DD');
          break;
        case 'day':
          this.datetime_show = this.datetime.format('YYYY-MM-DD');
          break;
        default:
          this.datetime_show = this.datetime.format('YYYY-MM-DD HH:00');
          break;
      }
    },
    move_start() {
      var dt = this.min_date.clone();
      this.date = dt.format('YYYY-MM-DD');
      this.time = dt.hours();
      this.$refs['t' + this.time].$el.click();
    },
    move_end() {
      var dt = this.max_date.clone();
      this.date = dt.format('YYYY-MM-DD');
      this.time = dt.hours();
      this.$refs['t' + this.time].$el.click();
    },
    move_backward() {
      var dt = this.datetime.clone();
      dt.subtract(this.steps[this.aggrunit], `${this.aggrunit}s`);

      if (!dt.isBefore(this.min_date)) {
        this.date = dt.format('YYYY-MM-DD');
        this.time = dt.hours();
        this.$refs['t' + this.time].$el.click();
      }
    },
    move_forward() {
      var dt = this.datetime.clone();
      dt.add(this.steps[this.aggrunit], `${this.aggrunit}s`);

      if (!dt.isAfter(this.max_date)) {
        this.date = dt.format('YYYY-MM-DD');
        this.time = dt.hours();
        this.$refs['t' + this.time].$el.click();
      }
      
    },
    select(id) {
      this.selected = id;
    },
    lock_app(lock) {
      this.lock = lock;
      // console.log(lock);
    },
    plot_selected() {
      this.$refs.plotComponent.add_station(this.selected);
    },
    show_event(id) {
      console.log('SHOW ' + this.city + ' ' + id);
      let evt = this.events[this.city].filter(evt => evt.id == id)[0];

      // console.log(evt);

      this.aggrunit = evt.aggr;
      this.date = evt.date;
      this.time = evt.time;
      this.$refs['t' + this.time].$el.click();
      this.varspace = 'meteo';
      this.variable['meteo'] = evt.var;
      this.standardize = evt.anomaly;
    },
    handlePlotClick(plotData) {
      // Обработчик клика по графику — устанавливает дату и час
      this.date = plotData.date;
      this.time = plotData.hour;
      this.$nextTick(() => {
        if (this.$refs['t' + plotData.hour]) {
          this.$refs['t' + plotData.hour].$el.click();
        }
      });
    },
    allowedHours: v => v % 3,
    setBorderWidth() {
      let i = this.$refs.drawer.$el.querySelector(
        ".v-navigation-drawer__border"
      );
      i.style.width = this.story.border + "px";
      i.style.cursor = "ew-resize";
    },
    setEvents() {
      const minSize = this.story.border;
      const el = this.$refs.drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      const vm = this;
      const direction = el.classList.contains("v-navigation-drawer--right")
        ? "right"
        : "left";

      function resize(e) {
        document.body.style.cursor = "ew-resize";
        let f = direction === "right"
          ? document.body.scrollWidth - e.clientX
          : e.clientX;
        el.style.width = f + "px";
      }

      drawerBorder.addEventListener(
        "mousedown",
        function(e) {
          if (e.offsetX < minSize) {
            el.style.transition ='initial'; document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        function() {
          el.style.transition ='';
          vm.story.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    },
    redraw_events() {
      this.eventkey = 1;
      // this.eventkey += 1;
      // console.log('yeah');
    }
  },

  async mounted() {
    this.setBorderWidth();
    this.setEvents();

    var self = this;

    // Параллельная загрузка данных pdk
    const fetchPdk = async () => {
      try {
        const response = await fetch(`${self.nodehost}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            action: 'get',
            source: 'pdk',
            dimension: 'temporal'
          })
        });
        
        const data = await response.json();
        const pdk_data = data;

        pdk_data.forEach((row) => {
          self.pdk[row.varname] = row.limit_value_cc;
        });

      } catch (error) {
        console.error('Error fetching pdk data:', error);
      }
    };

    // Параллельная загрузка ограничений для всех городов
    const fetchLimits = async (city) => {
      try {
        const response = await fetch(`${self.nodehost}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            action: 'get',
            source: 'limits',
            dimension: 'temporal',
            city: city
          })
        });
        
        const data = await response.json();
        const limits = data[0];
        self.min_date_all[city] = moment.utc(limits.min_time).tz(self.tz);
        self.max_date_all[city] = moment.utc(limits.max_time).tz(self.tz);

        if (city == self.city) {
          self.min_date = self.min_date_all[city].clone();
          self.max_date = self.max_date_all[city].clone();
          self.datetime = self.max_date.clone();
          self.date = self.datetime.format('YYYY-MM-DD');
          self.time = self.datetime.hours();
          if (self.$refs['t' + self.time]) {
            self.$refs['t' + self.time].$el.click();
          }
        }

      } catch (error) {
        console.error('Error fetching limits for city ' + city + ':', error);
      }
    };

    // Параллельная загрузка событий для всех городов
    const fetchEvents = async (city) => {
      console.log(city);
      try {
        const response = await fetch(`${self.nodehost}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            action: 'fetch',
            source: 'events',
            city: city
          })
        });
        
        const data = await response.json();
        const evts = data;
        self.events[city] = [];
        
        for (let evt of evts) {
          self.events[city].push({
            id: evt.name,
            date: moment(new Date(new Date(evt.date * 8.64e+7 + new Date('1899-12-30').getTime()).setHours(evt.time * 24))).format('YYYY-MM-DD'),
            time: evt.time * 24,
            var: evt.var,
            aggr: evt.aggr,
            anomaly: evt.anomaly == 1
          })
        }
        
      } catch (error) {
        console.error('Error fetching events for city ' + city + ':', error);
      }
    };

     // Создаем массив всех загрузок
    const loadPromises = [
      fetchPdk(),
      fetchLimits('moscow'),
      fetchLimits('spb'),
      fetchEvents('moscow'),
      fetchEvents('spb')
      // ...Object.keys(this.events).map(city => fetchLimits(city)),
      // ...Object.keys(this.events).map(city => fetchEvents(city))
    ];

      // Запускаем все загрузки параллельно и ждем завершения
    await Promise.all(loadPromises);
    
    // Все данные загружены
    this.loading_app = false;
  }
};
</script>

<template>
  <v-app>
    <div class="mapcontainer">
      <MapComponent
        :city="city"
        :nodehost="nodehost"
        :pdk="pdk" 
        :netatmo_vars="netatmo_vars"
        :aggrunit="aggrunit"
        :aggrunits="aggrunits"
        :filter_level="filter_level"
        :filtering="filtering.length > 0"
        :datetime="datetime"
        :show_netatmo="show_netatmo"
        :show_rhm="show_rhm"
        :show_air="show_air"
        :variable="variable"
        :varspace="varspace"
        :standardize="standardize"
        :show_lyrs="show_lyrs"
            :background_stations="background_stations"
        :confidence="confidence_up"
        @select="select"
        @plot_selected="plot_selected"
        @set_loading_map="set_loading_map"
        @show_snackbar="show_snackbar"
        style="height:100%"
              :transparency="transparency"
              :interp="interp"
      />
    </div>

    <v-app-bar
      app
      color="info"
      dark
      dense
    >

      <v-app-bar-nav-icon @click.stop="options = !options"></v-app-bar-nav-icon>
      
      <v-app-bar-title>{{ $t('titles.main') }}</v-app-bar-title>
      
      <v-select
        v-model="city"
        :items="cities"
        item-text="text"
        item-value="value"
        required
        hide-details
        style="margin-left:6px; margin-bottom:12px; margin-top:12px; max-width: 220px; font-size: 1.2em; font-weight: bold;"
        :disabled="lock"
      ></v-select>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        height="5"
        color="deep-orange"
      ></v-progress-linear>

      <v-spacer></v-spacer>

      <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              plain 
              v-bind="attrs"
              v-on="on"
            >
              <country-flag :country='$i18n.locale == "en" ? "gb" : "ru"' size='small'/> {{ $i18n.locale }}
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              key="en"
              link
              @click="$i18n.locale = 'en'"
            >
              <v-list-item-title> <country-flag country='gb' size='small'/> English </v-list-item-title>
            </v-list-item>

            <v-list-item
              key="ru"
              link
              @click="$i18n.locale = 'ru'"
            >
              <v-list-item-title> <country-flag country='ru' size='small'/> Русский </v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>

      <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              plain 
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-help-box</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              key="help"
              link
              @click="show_help = true"
            >
              <v-list-item-title>{{ this.$i18n.t("menu.help") }}</v-list-item-title>
            </v-list-item>

            <v-list-item
              key="info"
              link
              @click="show_info = true"
            >
              <v-list-item-title>{{this.$i18n.t("menu.about")}}</v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>

      <v-btn @click.stop="story.show = !story.show" plain>
        <v-icon dark>
          mdi-book-open
        </v-icon>
      </v-btn>

    </v-app-bar>

    <v-navigation-drawer app v-model="options" width="260">
    <v-list-item>
      <v-list-item-content style="padding-bottom:0px">
        <v-list-item-title class="text-h6">
          {{ $t('titles.params') }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      
      <v-list dense>
        <v-list-item>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  readonly
                  dense
                  :label="$t('titles.date')"
                  v-bind="attrs"
                  v-on="on"
                  style="margin-top:12px"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu2 = false"
                hide-details
                :locale="$i18n.locale"
                :min="min_date.format('YYYY-MM-DD')"
                :max="max_date.format('YYYY-MM-DD')"
              ></v-date-picker>
            </v-menu>
        </v-list-item>  

        <v-list-item>
          <p class="caption" style="color:#616161;padding-top:0px">
            {{ $t('titles.term') }}
          </p>
        </v-list-item>

        <v-list-item>
          <v-btn-toggle v-model="time" dense mandatory style="margin-top:-10px">
            <v-col style="display:flex; flex-direction:column; gap:2px; padding:0;">
              <div style="display:flex; flex-wrap:nowrap; justify-content:center; gap:2px;">
                <v-btn depressed tile value=0 ref="t0" :disabled="aggrunit != 'hour' || !show_time.t0" style="min-width:38px; padding:0 6px;">
                  00
                </v-btn>
                <v-btn depressed tile value=3 ref="t3" :disabled="aggrunit != 'hour' || !show_time.t3" style="min-width:38px; padding:0 6px;">
                  03
                </v-btn>
                <v-btn depressed tile value=6 ref="t6" :disabled="aggrunit != 'hour' || !show_time.t6" style="min-width:38px; padding:0 6px;">
                  06
                </v-btn>
                <v-btn depressed tile value=9 ref="t9" :disabled="aggrunit != 'hour' || !show_time.t9" style="min-width:38px; padding:0 6px;">
                  09
                </v-btn>
              </div>
              <div style="display:flex; flex-wrap:nowrap; justify-content:center; gap:2px;">
                <v-btn depressed tile value=12 ref="t12" :disabled="aggrunit != 'hour' || !show_time.t12" style="min-width:38px; padding:0 6px;">
                  12
                </v-btn>
                <v-btn depressed tile value=15 ref="t15" :disabled="aggrunit != 'hour' || !show_time.t15" style="min-width:38px; padding:0 6px;">
                  15
                </v-btn>
                <v-btn depressed tile value=18 ref="t18" :disabled="aggrunit != 'hour' || !show_time.t18" style="min-width:38px; padding:0 6px;">
                  18
                </v-btn>
                <v-btn depressed tile value=21 ref="t21" :disabled="aggrunit != 'hour' || !show_time.t21" style="min-width:38px; padding:0 6px;">
                  21
                </v-btn>
              </div>
            </v-col>
            
          </v-btn-toggle>
        </v-list-item>

        <v-list-item>
          <div style="display:flex; flex-wrap:nowrap; justify-content:flex-start; gap:0px;">
            <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed tile @click="move_start" small v-bind="attrs" v-on="on" :disabled="first_date">
                      <v-icon color="grey darken-3" dense>mdi-step-backward</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('hints.first') }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed tile @click="move_backward" small v-bind="attrs" v-on="on" :disabled="first_date">
                      <v-icon color="grey darken-3" dense>mdi-arrow-left-thick</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('hints.prev') }}</span>
                </v-tooltip>
                
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed tile @click="move_forward" small v-bind="attrs" v-on="on" :disabled="final_date">
                      <v-icon color="grey darken-3" dense>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('hints.next') }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed tile @click="move_end" small v-bind="attrs" v-on="on" :disabled="final_date">
                      <v-icon color="grey darken-3" dense>mdi-step-forward</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('hints.last') }}</span>
                </v-tooltip>
          </div>
        </v-list-item>

        <v-list-item>
          <p class="caption" >
            {{ $t('periods')[this.aggrunit] + ': ' + datetime_show }}
          </p>
        </v-list-item>

        <v-list-item>
          <v-select
            v-model="aggrunit"
            :items="aggrunits"
            item-text="text"
            item-value="value"
            required
            hide-details
            style="margin-bottom:12px; margin-top:0px"
            :label="$t('titles.period')"
            :disabled="lock"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <p class="caption" style="color:#616161;padding-top:0px">
            {{ $t('titles.confidence') }}
          </p>
          <v-slider
              style="color:#616161;margin-top:-15px"
              v-model="confidence"
              :max="100"
              class="align-center"
              step="5"
              dense
              @mouseup="confidence_up = confidence"
              hide-details
              track-color="green lighten-4"
              :thumb-size="24"
              :color='aggrunit=="hour" ? "grey" : "green darken"'
              :thumb-color='aggrunit=="hour" ? "grey" : "green darken"'
              :disabled="aggrunit=='hour'"
            >
            </v-slider>
            <p class="caption">
              {{ aggrunit!="hour" ? confidence + "%": ''}}
            </p>
        </v-list-item>

        <v-tabs v-model="tab" height="25px" style="margin-top:0px;padding-top:0px; margin-left:15px">
          <v-tab key="meteo" :disabled="lock">{{ $t('titles.meteo') }}</v-tab>
          <v-tab key="air" :disabled="lock">{{ $t('titles.air') }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="meteo">
            <v-list-item>
              <v-list-item-content>
                <!-- <v-list-item-title class="text-h7">
                  {{ $t('titles.var') }}
                </v-list-item-title> -->
                <!-- <v-list-item-title class="text-h6"> -->
                  {{ $t('vars')['meteo'][variable.meteo] }}
                <!-- </v-list-item-title> -->
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-btn-toggle v-model="variable.meteo" dense>
                <v-col>
                  <v-row>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            :disabled="lock"
                            ref="vtemperature"
                            depressed tile value="temperature" 
                            v-bind="attrs"
                            v-on="on">
                          <v-icon>mdi-thermometer</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('vars')[varspace]['temperature'] }}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            :disabled="lock"
                            ref="vhumidity"
                            depressed tile value="humidity"
                            v-bind="attrs"
                            v-on="on">
                          <v-icon>mdi-water-percent</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('vars')[varspace]['humidity'] }}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                      <v-btn
                            :disabled="lock"  
                            ref="vpressure"
                            depressed tile value="pressure"
                            v-bind="attrs"
                            v-on="on">
                        <v-icon>mdi-alpha-h-circle-outline</v-icon>
                      </v-btn>
                      </template>
                      <span>{{ $t('vars')[varspace]['pressure'] }}</span>
                    </v-tooltip>

                  </v-row>
                  
                  <v-row>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="lock"
                            ref="vprec" 
                            depressed tile value="prec"
                            v-bind="attrs"
                            v-on="on">
                          <v-icon>mdi-weather-pouring</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('vars')[varspace]['prec'] }}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                      <v-btn
                            :disabled="lock"
                            ref="vcloud"
                            depressed tile value="cloud"
                            v-bind="attrs"
                            v-on="on">
                        <v-icon>mdi-weather-partly-cloudy</v-icon>
                      </v-btn>
                      </template>
                      <span>{{ $t('vars')[varspace]['cloud'] }}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="lock"
                            ref="vwind" 
                            depressed tile value="wind"
                            v-bind="attrs"
                            v-on="on">
                          <v-icon>mdi-weather-windy</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('vars')[varspace]['wind'] }}</span>
                    </v-tooltip>
                  </v-row>

                  <v-row>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn 
                            :disabled="lock"
                            ref="vpet"
                            depressed tile value="pet"
                            v-bind="attrs"
                            v-on="on">
                            <v-icon>mdi-alpha-p</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('vars')[varspace]['pet'] }}</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :disabled="lock"
                            ref="vutci" 
                            depressed tile value="utci"
                            v-bind="attrs"
                            v-on="on">
                            <v-icon>mdi-alpha-u</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('vars')[varspace]['utci'] }}</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :disabled="lock"
                            ref="vmrt" 
                            depressed tile value="mrt"
                            v-bind="attrs"
                            v-on="on">
                            <v-icon>mdi-alpha-m</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('vars')[varspace]['mrt'] }}</span>
                      </v-tooltip>

                  </v-row>

                </v-col>
                
              </v-btn-toggle>
            </v-list-item>
            
            <v-list-item style="margin-top:0px">
              <v-switch
              style="margin-top:0px"
                v-model="show_rhm"
                :label="$t('titles.rhm')"
                color="primary"
                dense
                flat
                hide-details
              ></v-switch>
            </v-list-item>
            
            <v-list-item style="margin-top:0px">
              <v-switch
                v-model="show_netatmo"
                label="Netatmo"
                :color="aggrunit=='hour' ? 'primary' : 'grey'"
                dense
                flat
                hide-details
                :disabled="aggrunit!='hour'"
                style="margin-top:-10px"
              ></v-switch>
            </v-list-item>

            <v-list-item style="padding-left:5px">
              <v-select
                v-model="filter_level"
                :items="levels"
                item-text="text"
                item-value="value"
                required
                hide-details
                style="margin:12px;padding-top:0px;"
                :label="$t('titles.level')"
                :disabled="filtering!='Yes' || aggrunit!='hour'"
              ></v-select>
              <v-btn-toggle multiple tile dense borderless v-model="filtering">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        value="Yes" 
                        :disabled="aggrunit!='hour'"
                        v-bind:color="filtering.length > 0 ? 'pink lighten-4' : ''" 
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-filter</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('hints.filter') }}</span>
                </v-tooltip>
              </v-btn-toggle>
            </v-list-item>
          </v-tab-item>
          
          <v-tab-item key="air">
            <v-list-item>
              <v-select
                v-model="variable.air"
                :items="vars.air[city]"
                item-text="text"
                item-value="value"
                required
                hide-details
                style="padding-top:0px; margin-top:0px; margin-right:10px"
                :disabled="lock"
              >
                <template v-slot:item="{ item }">
                  <div v-html="item.text"></div>
                </template>
                <template v-slot:selection="{ item }">
                  <div v-html="item.text"></div>
                </template>
              </v-select>
            </v-list-item>
          </v-tab-item>
        </v-tabs-items>

        <v-list-item style="margin-top:12px">
          <v-list-item-content>
            <v-list-item-title class="text-h7">
              {{ $t('titles.layers') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item >
          <v-btn-toggle style="padding-top:0px;margin-top:-10px" 
          multiple tile dense borderless v-model="show_lyrs">
            <v-col>
              <v-row>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed tile value="points"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-circle-medium</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('hints.stations') }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed tile value="fields"
                        v-bind="attrs"
                        v-on="on">
                      <v-icon>mdi-egg-fried</v-icon>
                    </v-btn>
                    </template>
                    <span>{{ $t('hints.fields') }}</span>
                  </v-tooltip>
              </v-row>
            </v-col>
          </v-btn-toggle>
          <v-select
            v-model="interp"
            :items="interp_methods"
            item-text="text"
            item-value="value"
            required
            hide-details
            style="margin:12px;padding-top:0px;margin-top:5px;width:60px"
            :label="$t('titles.interp')"
            :disabled="!show_lyrs.includes('fields')"
          ></v-select>
        </v-list-item>

        <v-list-item style="margin-top:-15px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-checkbox
                
                v-model="standardize"
                :label="$t('titles.relation')"
                color="orange darken-3"
                hide-details
                dense
                flat
                v-bind="attrs"
                v-on="on"
              ></v-checkbox>
            </template>
            <span>Показать разницу с фоновыми метеостанциями</span>
          </v-tooltip>

        </v-list-item>

        <v-list-item style="flex-direction: column; align-items: stretch; border-top: 1px solid #e0e0e0; padding-top:8px; margin-top:8px;">
          <p class="caption" style="color:#616161; padding-top:0px; margin-bottom:4px;">
            {{ $t('titles.map_transparency') }}
          </p>
          <div style="display:flex; align-items:center; gap:12px;">
            <v-slider
              v-model="transparency"
              :max="100"
              class="align-center"
              step="5"
              dense
              hide-details
              track-color="blue lighten-4"
              :thumb-size="24"
              color="blue darken-2"
              thumb-color="blue darken-2"
              style="flex:1;"
            >
            </v-slider>
            <p class="caption" style="min-width:30px; margin:0; text-align:right;">
              {{ transparency }}%
            </p>
          </div>
        </v-list-item>

      </v-list>
    
    </v-navigation-drawer>

    <v-navigation-drawer
      ref="drawer"
      app
      right
      :width="story.width"
      v-model="story.show"
    >
  
      <v-container fluid>
          <EventComponent :key="eventkey" :lock="lock" :events="events" :apihost="apihost" :city="city" @show_event="show_event" @redraw_events="redraw_events"/>
      </v-container>

    </v-navigation-drawer>

    <v-main style="padding-top:0;position:absolute;bottom:0;width:100%">   
            <v-snackbar
        v-model="snackbar"
        app
        top
        color="grey darken-2"
      >
        {{ snackbar_message }}

        <template v-slot:action="{ attrs }">
          <v-btn
            v-if="typeof min_confidence === 'number' && snackbar_message === $t('messages.confidence_hint', { confidence: min_confidence })"
            color="grey darken-3"
            v-bind="attrs"
            depressed
            @click="snackbar = false; confidence = min_confidence; confidence_up = min_confidence"
          >
            {{ $t('messages.yes') }}
          </v-btn>

          <v-btn
            color="grey darken-2"
            v-bind="attrs"
            depressed
            @click="snackbar = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <v-container fluid>
          <PlotComponent
            ref="plotComponent"
            @lock_app="lock_app"
            :pdk="pdk"
            :confidence="confidence_up"
            :city="city"
            :nodehost="nodehost" 
            :variable="variable[varspace]"
            :varspace="varspace" 
            :standardize="standardize" 
            :background_stations="background_stations"
            :default_background_stations="default_background_stations"
            :varnames="$t('vars')"
            :selected="selected"
            :min_date="min_date != null ? min_date.format('YYYY-MM-DD') : null" 
            :max_date="max_date != null ? max_date.format('YYYY-MM-DD') : null" 
            @plot_click="handlePlotClick"
            @update:background_stations="background_stations = $event"
            :appdate="datetime != null ? datetime.format('YYYY-MM-DD') : null"
            :apphour="Number(time)"
            :aggrunit_ext="aggrunit"/>
      </v-container>
    </v-main>

    <v-dialog v-model="show_help" max-width="800">
      <v-card>
        <v-toolbar app dark color="success">
          <v-toolbar-title>{{ $t('menu.help') }}</v-toolbar-title>

          <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                style="width:auto"
                dark
                text
                @click="show_help = false"
              >
                {{ $t('menu.close') }}
              </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-container grid-list-md>
          <v-row>
              <v-col>
                  <div id="help">
                  </div>
              </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="show_info" max-width="800">
      <v-card>
        <v-toolbar app dark color="success">
          <v-toolbar-title>{{ $t('menu.about') }}</v-toolbar-title>

          <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                style="width:auto"
                dark
                text
                @click="show_info = false"
              >
                {{ $t('menu.close') }}
              </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-container grid-list-md>
          <v-row>
              <v-col>
                  <div id="info">
                  </div>
              </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<style scoped>
  .v-btn {
    width: 56px;
    min-width: 56px;
  }

  .mapcontainer {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100vh;
  }
</style>